export type PinSnapshot = {
  workbookName: string;
  sheetName: string;
  address: string;
  rowCount: number;
  columnCount: number;
  values: unknown[][];
  pinnedAt: number;
};

const KEY_PREFIX = "myai_excel.pin.";

function key(sessionId: string): string {
  return `${KEY_PREFIX}${sessionId}`;
}

export function getPin(sessionId: string): PinSnapshot | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(key(sessionId));
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PinSnapshot;
  } catch {
    return null;
  }
}

export function setPin(sessionId: string, pin: PinSnapshot): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(key(sessionId), JSON.stringify(pin));
}

export function clearPin(sessionId: string): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(key(sessionId));
}
